import { render, staticRenderFns } from "./SignUpModalShell.vue?vue&type=template&id=01d76aba&scoped=true"
import script from "./SignUpModalShell.vue?vue&type=script&lang=js"
export * from "./SignUpModalShell.vue?vue&type=script&lang=js"
import style0 from "./SignUpModalShell.vue?vue&type=style&index=0&id=01d76aba&prod&lang=css"
import style1 from "./SignUpModalShell.vue?vue&type=style&index=1&id=01d76aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d76aba",
  null
  
)

export default component.exports